import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import ReactHtmlParser from 'react-html-parser';
import { get } from 'lodash';

const CustomFormGroup = ({ field, containerStyle, containerClass, extraClass, children, className, ...remainingProps }) => {
  const [topOffset, setTopOffset] = useState('0px')
  const [iconHeight, setIconHeight] = useState('34')
  const [controlLabelHeight, setControlLabelHeight] = useState('30')
  const [marginBottom, setMarginBottom] = useState('0')
  const requiredFields = useSelector(state => state.requiredFields)
  const validationKey = get(field, 'validationKey', null)
  if (validationKey == 'profile_elements_placement_intended_vacate') {
    requiredFields.profile_elements_placement_intended_vacate = requiredFields.profile_elements_placement_intended_start;
  }
  const validationKeyValid = validationKey && (
    typeof validationKey == 'boolean' && validationKey == true ||
    requiredFields[validationKey]
  )
  const container = React.createRef()

  useEffect(() => {
    if (!container) { return }
    let cont = $(container.current)
    let newOffset = (cont.outerHeight() / 2) - (iconHeight / 2) - (marginBottom / 2)
    let controlLabelExists = React.Children.toArray(children).filter(c => c.props.bsClass == 'control-label').length > 0
    if (controlLabelExists) { newOffset += (controlLabelHeight / 2) }
    setTopOffset(`${newOffset}px`)
  }, [field])

  const valid = () => (
    typeof field.valid === 'boolean' && field.valid
  )

  const showAsterisk = () => (
    validationKeyValid
  )

  const shouldValidate = () => (
    validationKeyValid &&
    (typeof field.val == 'boolean' || field.val) &&
    typeof field.valid === 'boolean'
  )

  const icon = () => {
    let klass = get(field, 'loading', null) ? 'fa-circle-notch fa-spin fa-blue' : ''
    if (shouldValidate()){
      klass = valid() ? 'fa-check-circle' : 'fa-times-circle'
    }
    return(
      <span
        className={`form-control-feedback ${extraClass}`}
        ref={ele => {
          if (ele) { ele.style.setProperty('top', topOffset, 'important') }
        }}>
        <i className={`fa fa-2x ${klass}`}></i>
      </span>
    )
  }

  const formGroupClass = () => {
    let klass = ''
    if (shouldValidate()){
      klass = valid() ? 'has-success' : 'has-error'
    }
    return(`form-group has-feedback ${klass}`)
  }

  const validationMessage = () => (
    shouldValidate() &&
    !valid() &&
    <div className='error-message'>
      { ReactHtmlParser(get(field, `errors.${field.failedValidation}`, '')) }
    </div>
  )

  const profileElementActive = () => {
    let activeProfileElements = get(useSelector(state => state.user), 'guest.type.guest_profile_elements', [])
    return (
      !Object.keys(field).includes('profileElement') ||
      (typeof field.profileElement === 'boolean' && field.profileElement == true) ||
      (typeof field.profileElement === 'string' && activeProfileElements.includes(field.profileElement))
    )
  }

  const dependencyMet = () => (
    !Object.keys(field).includes('dependencyMet') ||
    field.dependencyMet()
  )

  const fieldActive = () => (
    profileElementActive() && dependencyMet()
  )

  const validationLabel = () => (
    validationKeyValid && field.validationLabel
  )

  const updatedChildren = () => (
    React.Children.map(children, child => {
      if(!child) { return }
      if(child.props.bsClass != 'control-label'){ return child }
      let asterisk = showAsterisk() ? '<span style="color:red;font-size:15px;">*</span>' : ''
      return (
        React.cloneElement(child, {
          children: ReactHtmlParser(`${child.props.children} ${asterisk} ${validationLabel() || ''}`)
        })
      )
    })
  )

  return (
    fieldActive() &&
    <div ref={container} style={containerStyle} className={containerClass}>
      <FormGroup
        {...remainingProps}
        className={`${className} ${formGroupClass()}`}
        style={{marginRight: '44px'}}>
        {icon()}
        {updatedChildren()}
        {validationMessage()}
      </FormGroup>
    </div>
  );
}
export default React.memo(CustomFormGroup)
